import { render, staticRenderFns } from "./CoinPurchasePendingPayPay.vue?vue&type=template&id=c065932a&scoped=true"
import script from "./CoinPurchasePendingPayPay.vue?vue&type=script&lang=ts"
export * from "./CoinPurchasePendingPayPay.vue?vue&type=script&lang=ts"
import style0 from "./CoinPurchasePendingPayPay.vue?vue&type=style&index=0&id=c065932a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c065932a",
  null
  
)

export default component.exports